export default __webpack_public_path__ + "static/media/imit.6caeffcf.png";